import {
  Banknote,
  BarChart3,
  CalendarRange,
  Building2,
  CalendarClock,
  LayoutDashboard,
  Receipt,
  Repeat,
  Settings,
  Wallet,
  type LucideIcon,
} from 'lucide-react'
import type { UserRole } from './types'

export interface NavItem {
  label: string
  to: string
  icon: LucideIcon
  matchPrefix?: string
  roles?: UserRole[]
}

const STAFF: UserRole[] = ['ADMIN', 'PARTNER', 'CONTRACTOR']
const FINANCE: UserRole[] = ['ADMIN', 'PARTNER']

export const primaryNav: NavItem[] = [
  { label: 'Dashboard', to: '/', icon: LayoutDashboard, roles: STAFF },
  { label: 'Uren', to: '/uren', icon: CalendarClock, matchPrefix: '/uren' },
  { label: 'Facturen', to: '/facturen', icon: Receipt, matchPrefix: '/facturen', roles: FINANCE },
  { label: 'Terugkerend', to: '/terugkerend', icon: Repeat, roles: FINANCE },
  { label: 'Klanten', to: '/klanten', icon: Building2, matchPrefix: '/klanten', roles: FINANCE },
  { label: 'Mijn uitbetalingen', to: '/mijn-uitbetalingen', icon: Wallet, matchPrefix: '/mijn-uitbetalingen', roles: STAFF },
  { label: 'Alle uitbetalingen', to: '/uitbetalingen', icon: Banknote, matchPrefix: '/uitbetalingen', roles: FINANCE },
  { label: 'Vooruitblik', to: '/vooruitblik', icon: CalendarRange, roles: FINANCE },
  { label: 'Rapportages', to: '/rapportages', icon: BarChart3, roles: FINANCE },
  { label: 'Instellingen', to: '/instellingen', icon: Settings },
]

export function navForRole(role: UserRole | undefined, personScoped = false): NavItem[] {
  if (!role) return primaryNav
  return primaryNav.filter((item) => {
    if (!item.roles) return true
    if (personScoped) return false
    return item.roles.includes(role)
  })
}
